/**
 * The one real consumer of authStore.isOffline. The flag was written on every
 * cold-start outcome but read nowhere outside tests — a state nobody can see
 * is a state nobody trusts. Same surface pattern as SyncStatusIndicator: a
 * self-hiding titlebar element (popup toasts are globally disabled app-wide),
 * amber like every other "degraded, not broken" signal here.
 *
 * It disappears on its own: services/authReconnect's loop flips isOffline
 * back to false the moment a retry lands, so this label never needs a
 * dismiss affordance — "reconnecting" is literally what the app is doing.
 */
import React from 'react';
import { WifiOff } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

const OfflineIndicator = () => {
  const isOffline = useAuthStore((s) => s.isOffline);
  if (!isOffline) return null;

  return (
    <span
      role="status"
      className="flex items-center gap-1 px-2 py-0.5 rounded-md text-amber-600 bg-amber-50 dark:text-amber-400 dark:bg-amber-950/30"
      style={{ WebkitAppRegion: 'no-drag', fontSize: 10, fontWeight: 600, whiteSpace: 'nowrap' }}
      title="Could not reach Apiboo. You are still signed in — retrying in the background."
    >
      <WifiOff size={12} aria-hidden />
      Offline — reconnecting…
    </span>
  );
};

export default OfflineIndicator;
